import get from 'lodash/get';
import reduce from 'lodash/reduce';
import includes from 'lodash/includes';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import cart from './cart';
import chargedCart from './chargedCart';
import inventory from './inventory';
import cartItems from './cartItems';
import status from './status';
import products from './products';

export default combineReducers({
  cart,
  cartItems,
  chargedCart,
  inventory,
  status,
  products,
});

export const selectPantry = state => state.pantry;

export const selectCart = state => get(selectPantry(state), 'cart.pantryCart', {});
export const selectCartIsLoading = state => get(selectCart(state), 'isLoading', false);

export const selectChargedCart = state => get(selectPantry(state), 'chargedCart.pantryCart', {});
export const selectChargedCartIsLoading = state =>
  get(selectCart(state), 'chargedCart.isLoading', false);
export const selectChargedCartError = state => get(selectCart(state), 'chargedCart.isError', false);

export const selectInventory = state => get(selectPantry(state), 'inventory.items', {});
export const selectInventoryError = state => get(selectPantry(state), 'inventory.isError', false);
export const selectInventoryLoading = state =>
  get(selectPantry(state), 'inventory.isLoading', false);
export const selectInventoryById = (state, id) => get(selectInventory(state), id, {});

export const selectStatus = state => selectPantry(state).status;

export const selectProducts = state => selectPantry(state).products;
export const selectNumProducts = state => Object.keys(selectProducts(state)).length;
export const selectProductById = (state, id) => get(selectProducts(state), id, {});

const selectCartItemsSlice = state => get(selectPantry(state), 'cartItems', {});
export const selectNumCartItems = state => Object.keys(selectCartItemsSlice(state)).length;
export const selectItemInCartById = (state, id) =>
  includes(Object.keys(selectCartItemsSlice(state)), id);
export const selectCartItems = createSelector(
  [selectCartItemsSlice, selectInventory],
  (cartItems, inventoryItems) =>
    reduce(
      cartItems,
      (resultObj, item, itemUpc) => {
        const inventoryItem = get(inventoryItems, itemUpc, {});
        resultObj[itemUpc] = {
          ...item,
          soldOut:
            inventoryItem.available === false || inventoryItem.quantityAvailable < item.quantity,
        };
        return resultObj;
      },
      {}
    )
);
export const selectCartItem = (state, id) => get(selectCartItems(state), id, {});
